import AlertMessageActions from 'actions/AlertMessageActions';
import PageLoaderActions from 'actions/PageLoaderActions';
import BaseAction from 'packages/Base/actions/BaseAction';
import ContravvenzioneService from '../services/ContravvenzioneService';

export const contravvenzioneConsts = {
	INITIALIZE: 'LWO_CONTRAVVENZIONE_INITIALIZE',
	SET_FORM_DATA: 'LWO_CONTRAVVENZIONE_SET_FORM_DATA',
	SET_MAIN_TAB: 'LWO_CONTRAVVENZIONE_SET_MAIN_TAB',
	SET_SEARCH: 'LWO_CONTRAVVENZIONE_SET_SEARCH',
	SEARCHED: 'LWO_CONTRAVVENZIONE_SEARCH',
	RESET: 'LWO_CONTRAVVENZIONE_RESET',
	LOADING: 'LWO_CONTRAVVENZIONE_LOADING',	
	LOADED: 'LWO_CONTRAVVENZIONE_LOADED',
	CREATED: 'LWO_CONTRAVVENZIONE_CREATED',
	CREATED_CUSTOMER: 'LWO_CONTRAVVENZIONE_CREATED_CUSTOMER',
	UPDATED: 'LWO_CONTRAVVENZIONE_UPDATED',
	UPDATED_CUSTOMER: 'LWO_CONTRAVVENZIONE_UPDATED_CUSTOMER',
	FIELDS_UPDATED: 'LWO_CONTRAVVENZIONE_FIELDS_UPDATED',
  REMOVED: 'LWO_CONTRAVVENZIONE_REMOVED',
  SORT: 'LWO_CONTRAVVENZIONE_SORT',
	SORTED: 'LWO_CONTRAVVENZIONE_SORTED',
	LIST_ERROR: 'LWO_CONTRAVVENZIONE_LIST_ERROR',
  ITEM_ERROR: 'LWO_CONTRAVVENZIONE_ITEM_ERROR',
	MEDIA_SINGLE_UPLOADED: 'LWO_CONTRAVVENZIONE_MEDIA_SINGLE_UPLOADED',
	MEDIA_REMOVED: 'LWO_CONTRAVVENZIONE_MEDIA_REMOVED',
	EXPORTED: 'LWO_CONTRAVVENZIONE_EXPORTED',

	ITEMS_LOADED: 'LWO_CONTRAVVENZIONE_ITEMS_LOADED',
	ITEMS_RESET: 'LWO_CONTRAVVENZIONE_ITEMS_RESET',
  ITEMS_ADD_OR_UPDATE_SUCCESS: 'LWO_CONTRAVVENZIONE_ITEMS_ADD_OR_UPDATE_SUCCESS',
  ITEMS_ADD_OR_UPDATE_ERROR: 'LWO_CONTRAVVENZIONE_ITEMS_ADD_OR_UPDATE_ERROR',
  ITEMS_REMOVE_SUCCESS: 'LWO_CONTRAVVENZIONE_ITEMS_REMOVE_SUCCESS',
  ITEMS_REMOVE_ERROR: 'LWO_CONTRAVVENZIONE_ITEMS_REMOVE_ERROR',
}

export default class ContravvenzioneAction extends BaseAction {

	constructor() {
		super();
		this.service = new ContravvenzioneService();
		this.consts = contravvenzioneConsts;
		this.redirect = '/lawyer-one/contravvenzioni';
  }
  
  initialize(params) {
    return (dispatch) => {
      this.service.initialize(params)
      .then(response => {
        dispatch({
          type: this.consts.INITIALIZE,
          status: response.data.status,
          customers: response.data.customers
        })
      })
      .catch(error => {
        if( error.data && error.data.meta && error.data.meta.message)
          dispatch(AlertMessageActions.alertMessageError(error.data.meta.message));
        else if( error.data && error.data.message )
          dispatch(AlertMessageActions.alertMessageError(error.data.message));
        else
          dispatch(AlertMessageActions.alertMessageError(error.message));
      });
    }
  }


	setMainTab(index){
		return (dispatch) => {
			dispatch({
				type: this.consts.SET_MAIN_TAB,
				index: index
			});
		}
	}

	setFormData(formData){
		return dispatch => {
			dispatch({
				type: this.consts.SET_FORM_DATA,
				formData: formData
			})
		}
	}

  createCustomerPost( postData, ownProps ) {
		return (dispatch) => {
			dispatch(PageLoaderActions.show());
			this.service
			.createPost(postData).then( response => {
				dispatch({
					type: this.consts.CREATED_CUSTOMER,
					item: response.data.data,
					nextStep: 1
				});
				dispatch(PageLoaderActions.hide());
				dispatch(AlertMessageActions.alertMessageSuccess(response.data.meta.message));
			})
			.catch( error => {
				dispatch(PageLoaderActions.hide());
				if( error.response && error.response.data && error.response.data.meta )
					dispatch(AlertMessageActions.alertMessageError('Errore: ' + error.response.data.meta.message));
				else if( error.response && error.response.data && error.response.data.message )
					dispatch(AlertMessageActions.alertMessageError('Errore: ' + error.response.data.message));
				else
					dispatch(AlertMessageActions.alertMessageError('Errore: ' + error.status));
			});
		}
  }
  
  createCustomer( postData, ownProps ) {
		return (dispatch) => {
			dispatch(PageLoaderActions.show());
			this.service
			.create(postData).then( response => {
				dispatch({
					type: this.consts.CREATED_CUSTOMER,
					item: response.data.data,
					nextStep: 1
				});
				dispatch(PageLoaderActions.hide());
				dispatch(AlertMessageActions.alertMessageSuccess(response.data.meta.message));
			})
			.catch( error => {
				dispatch(PageLoaderActions.hide());
				if( error.response && error.response.data && error.response.data.meta )
					dispatch(AlertMessageActions.alertMessageError('Errore: ' + error.response.data.meta.message));
				else if( error.response && error.response.data && error.response.data.message )
					dispatch(AlertMessageActions.alertMessageError('Errore: ' + error.response.data.message));
				else
					dispatch(AlertMessageActions.alertMessageError('Errore: ' + error.status));
			});
		}
	}



	/**
   * Items
   */
	setItemsItem(item) {
		return (dispatch) => {
			dispatch({
				type: this.consts.ITEMS_LOADED,
				item
			});
		}
	}
	resetItemsItem() {
		return (dispatch) => {
			dispatch({
				type: this.consts.ITEMS_RESET
			});
		}
	}
  itemsAddOrUpdate(id, data) {
    return (dispatch) => {
			dispatch(PageLoaderActions.show());
			this.service
			.itemsAddOrUpdate(id, data).then( response => {
				dispatch({
					type: this.consts.ITEMS_ADD_OR_UPDATE_SUCCESS,
          item: response.data.data,
          meta: response.data.meta
				});
				dispatch(PageLoaderActions.hide());
			})
			.catch( error => {
				dispatch(PageLoaderActions.hide());
				var meta = {};
        
        if( error.data && error.data.meta && error.data.meta.message)
          meta = {
            message: error.data.meta.message,
            code: error.data.meta.code,
          }
        else if( error.data && error.data.message )
        meta = {
          message: error.data.message,
          code: error.data.code,
        }
        else
          meta = {
            message: "Error",
            code: error.status,
          }
        
        dispatch({
					type: this.consts.ITEMS_ADD_OR_UPDATE_ERROR,
          meta
				});
			});
		}
  }

  itemsRemove(id, data) {
    return (dispatch) => {
			dispatch(PageLoaderActions.show());
			this.service
			.itemsRemove(id, data).then( response => {
				dispatch({
					type: this.consts.ITEMS_REMOVE_SUCCESS,
          item: response.data.data,
          meta: response.data.meta
				});
				dispatch(PageLoaderActions.hide());
			})
			.catch( error => {
        dispatch(PageLoaderActions.hide());
        var meta = {};
        
        if( error.data && error.data.meta && error.data.meta.message)
          meta = {
            message: error.data.meta.message,
            code: error.data.meta.code,
          }
        else if( error.data && error.data.message )
        meta = {
          message: error.data.message,
          code: error.data.code,
        }
        else
          meta = {
            message: "Error",
            code: error.status,
          }
        
        dispatch({
					type: this.consts.ITEMS_REMOVE_ERROR,
          meta
				});
			});
		}
  }
}